import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'
import { EliminarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdGrupoContableVentaFormGroup = ({
  values,
  setValues,
  iError,
  iTouched,
  fIsSubmitting,
  gruposContablesVentas,
  actualizarGruposContablesVentas
}) => {
  const [mostrarSeleccionarCuentaModal, setMostrarSeleccionarCuentaModal] = React.useState(false)
  const [mostrarEliminarCuentaModal, setMostrarEliminarCuentaModal] = React.useState(false)
  const [dataGrupoContable, setDataGrupoContable] = React.useState(null)

  React.useEffect(() => {
    if (gruposContablesVentas.length === 1) {
      values.cuentaContableVenta = gruposContablesVentas[0]._id
      setValues(values)
    }
  }, [gruposContablesVentas, values, setValues])

  const onSuccess = React.useCallback(async () => {
    actualizarGruposContablesVentas()
    setMostrarSeleccionarCuentaModal(false)
  }, [actualizarGruposContablesVentas])

  const clickEliminarGrupoContable = React.useCallback(() => {
    const idTablaPersonalizada = gruposContablesVentas.find(x => x._id === values.cuentaContableVenta).id
    TablaPersonalizadaService.getAsEdicion(idTablaPersonalizada).then(({ data }) => {
      setDataGrupoContable(data)
      setMostrarEliminarCuentaModal(true)
    })
  }, [values, gruposContablesVentas])

  return (
    <>
      <Form.Group>
        <Form.Label text='VENTAS' htmlFor='select-gContablesVentas' sm={2} md={3} lg={2} alignRightAt='sm' />
        <Col sm={10} md={9} lg={10}>
          <Form.InputGroup>
            <Field name='cuentaContableVenta'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  id='select-gContablesVentas'
                >
                  <option value=''>Seleccionar</option>
                  {gruposContablesVentas &&
                    gruposContablesVentas.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarSeleccionarCuentaModal(true)}>+</Button>
              <Button className='bg-danger border border-danger' onClick={() => clickEliminarGrupoContable()}>
                -
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarSeleccionarCuentaModal && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarSeleccionarCuentaModal(false)}
          show={mostrarSeleccionarCuentaModal}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLEVENTA}
        />
      )}
      {mostrarEliminarCuentaModal && (
        <EliminarTablaPersonalizadaModal
          handleClose={e => setMostrarEliminarCuentaModal(false)}
          show={mostrarEliminarCuentaModal}
          modalData={dataGrupoContable}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA}
        />
      )}
    </>
  )
}

export default React.memo(IdGrupoContableVentaFormGroup)
